import React from 'react';
import { Container } from '@mui/material';
import About from '../components/About';
import Contact from './Contact';

function Home() {
  return (
    <Container sx={{ backgroundImage: `url('https://tom-house-huc6gadgb3c4cac8.z03.azurefd.net/images/background.png')`, backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',}} disableGutters maxWidth={false}>
      <About />
      <Contact />
    </Container>
  );
}

export default Home;